module.exports = __webpack_public_path__ + "img/REPLACEMENT-Work-From-Home-Household-Ergo2-scaled.ec071667.jpg";